import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-void text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 pt-20 pb-10">
        <div className="border-b border-white/10 pb-16">
          <h2 className="font-display font-black tracking-tighter leading-[0.9] text-[16vw] md:text-[12vw] lg:text-[8.5vw]">
            SCOOT<br />EDMONTON<span className="text-[#4cc3c7]">.</span>
          </h2>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mt-12">
            <p className="text-white/60 text-lg max-w-sm">
              Guided e-scooter tours through the River Valley, Old Strathcona, Downtown and beyond.
            </p>
            <a
              href="/#tours"
              data-testid="footer-book-cta"
              className="self-start bg-signal text-white px-8 py-4 text-sm font-bold uppercase tracking-widest hover:bg-white hover:text-void transition-colors duration-200"
            >
              Book a Tour
            </a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-8 pt-10">
          <div>
            <p className="font-display font-bold text-xl tracking-tighter">YEG SCOOT<span className="text-[#4cc3c7]">.</span></p>
            <p className="text-white/50 text-sm mt-2">10011 - 102 Avenue</p>
            <p className="text-white/50 text-sm mt-2">Edmonton, Alberta, Canada</p>
          </div>
          <div className="flex flex-col gap-2 font-mono text-sm text-white/60">
            <a href="mailto:ride@yegscoot.com" className="hover:text-signal transition-colors">ride@yegscoot.com</a>
            <span>+1 (825) 500-5133</span>
          </div>
          <div className="flex gap-5 text-white/60">
            <a href="https://www.instagram.com/yegscoot" aria-label="Instagram" className="hover:text-signal transition-colors"><Instagram size={20} /></a>
            <a href="mailto:ride@yegscoot.com" aria-label="Email" className="hover:text-signal transition-colors"><Mail size={20} /></a>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3 mt-12 text-xs text-white/40 font-mono uppercase tracking-widest">
          <span>© {new Date().getFullYear()} YEG SCOOT. All Rights Reserved.</span>
          <Link to="/admin/login" data-testid="admin-portal-link" className="hover:text-white/70 transition-colors">
            Admin Portal
          </Link>
        </div>
      </div>
    </footer>
  );
};
